import React from 'react';
import logo from './logo.svg';
import Button from '@material-ui/core/Button';
import * as helpers from './helpers.js'
import * as globals from './globals.js'
import * as Actions from './redux-actions.js'

import { useDispatch, useSelector } from 'react-redux'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory
} from "react-router-dom";

import LinearProgress from '@material-ui/core/LinearProgress'
import MessageBar from './MessageBar.jsx'
import Login from './Login.jsx'
import AdminPage, { AdminItems } from './AdminPage.jsx'



import './App.css';

function App() {
  const dispatch = useDispatch()
  const authenticated = useSelector(state => state.authenticated)
  const [checkLogin, setCheckLogin] = React.useState(false)
  const [loadDictionary, setLoadDictionary] = React.useState(false)

  React.useEffect(() => {

        
     if (! checkLogin) {

     helpers.getAPI(
         { func: function(data, resp) {
                 setCheckLogin(true)
                 if (resp.statusCode === 200) {
                    dispatch({type: Actions.LOGIN, user: data.user, role: data.role})
                 }
              }, 
           uri: globals.myAPIurl+'/logincheck'
         })
     }

     if (! loadDictionary) {
  
     helpers.getAPI(
         { func: function(resp) {
                 dispatch({type: Actions.LOAD_DICTIONARY,  value: resp})
                 console.log('DEBUG', 'DICTIONARY', resp); 
                 setLoadDictionary(true)

               }, 
           uri: globals.myAPIurl+'/getdict'
         })
    }


    }

  , [checkLogin, loadDictionary]);


  if (! checkLogin || ! loadDictionary) return (<div><MessageBar alert={{visible: false}}/><LinearProgress /></div>)

  return (
    <div className="App">
      
      <MessageBar alert={{visible: false}}/>

      { (authenticated) ? 

      <Router>
        <Switch>
          <Route path={"/:page?/:p1?/:p2?"} component={AdminPage} />} />


        </Switch>          
      </Router>
     
     :  <Login /> }

    </div>
  );
}

export default App;
